//# sourceMappingURL=auth.mjs.map
/// <reference types="./auth.d.mts" />
import * as $auth0 from "../../auth0_client/auth0/client.mjs";
import * as $auth0_options from "../../auth0_client/auth0/client/options.mjs";
import * as $vitools from "../../vitools/vitools.mjs";
import { Ok, CustomType as $CustomType, makeError } from "../gleam.mjs";

const FILEPATH = "src/altar/auth.gleam";

export class Authentication extends $CustomType {}
export const Mode$Authentication = () => new Authentication();
export const Mode$isAuthentication = (value) => value instanceof Authentication;

export class Invitation extends $CustomType {
  constructor(organization, invitation) {
    super();
    this.organization = organization;
    this.invitation = invitation;
  }
}
export const Mode$Invitation = (organization, invitation) =>
  new Invitation(organization, invitation);
export const Mode$isInvitation = (value) => value instanceof Invitation;
export const Mode$Invitation$organization = (value) => value.organization;
export const Mode$Invitation$0 = (value) => value.organization;
export const Mode$Invitation$invitation = (value) => value.invitation;
export const Mode$Invitation$1 = (value) => value.invitation;

export function client_id() {
  let $ = $vitools.get_env("AUTH0_CLIENT_ID");
  let client_id$1;
  if ($ instanceof Ok) {
    client_id$1 = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "altar/auth",
      45,
      "client_id",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 1198,
        end: 1259,
        pattern_start: 1209,
        pattern_end: 1222
      }
    )
  }
  return client_id$1;
}

function create_client(params) {
  let client_id$1 = client_id();
  let $ = $vitools.get_env("AUTH0_DOMAIN");
  let domain;
  if ($ instanceof Ok) {
    domain = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "altar/auth",
      36,
      "create_client",
      "Pattern match failed, no pattern matched the value.",
      { value: $, start: 910, end: 965, pattern_start: 921, pattern_end: 931 }
    )
  }
  let _pipe = $auth0_options.new$(domain, client_id$1);
  let _pipe$1 = $auth0_options.use_refresh_token(_pipe, true);
  let _pipe$2 = $auth0_options.use_refresh_token_fallback(_pipe$1, false);
  let _pipe$3 = $auth0_options.with_authorization_params(_pipe$2, params);
  return $auth0.create(_pipe$3);
}

function invite_client(organization, invitation) {
  let _pipe = $auth0_options.authorization_params();
  let _pipe$1 = $auth0_options.audience(_pipe, "https://api.steerlab.ai/");
  let _pipe$2 = $auth0_options.scope(_pipe$1, "openid profile email");
  let _pipe$3 = $auth0_options.organization(_pipe$2, organization);
  let _pipe$4 = $auth0_options.invitation(_pipe$3, invitation);
  return create_client(_pipe$4);
}

function auth_client() {
  let _pipe = $auth0_options.authorization_params();
  let _pipe$1 = $auth0_options.audience(_pipe, "https://api.steerlab.ai/");
  let _pipe$2 = $auth0_options.scope(_pipe$1, "openid profile email");
  return create_client(_pipe$2);
}

export function client(mode) {
  if (mode instanceof Authentication) {
    return auth_client();
  } else {
    let organization = mode.organization;
    let invitation = mode.invitation;
    return invite_client(organization, invitation);
  }
}
